export const ARCHE_ID = 'arche_customer_support';
export const ARCHE_PATH = `/a/${ARCHE_ID}`;
